import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function SponsorsStrip() {
  const [sponsors, setSponsors] = useState([]);

  useEffect(() => {
    api.get("/sponsors").then((r) => setSponsors(r.data.items || [])).catch(() => {});
  }, []);

  if (!sponsors.length) return null;

  // duplicate for seamless marquee scroll
  const loop = [...sponsors, ...sponsors];

  return (
    <section data-testid="sponsors-strip" className="bg-emerald-950 py-12 border-t border-b border-emerald-900">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 mb-6 flex items-center gap-4">
        <div className="text-[11px] uppercase tracking-[0.4em] text-amber-300 font-[Outfit] font-bold">Proudly Sponsored By</div>
        <div className="h-px flex-1 bg-amber-300/30" />
      </div>
      <div className="relative overflow-hidden">
        <div
          className="flex gap-10 px-6 lg:px-10 animate-[scroll_30s_linear_infinite] hover:[animation-play-state:paused]"
          style={{ width: "max-content" }}
        >
          {loop.map((s, i) => (
            <a
              key={`${s.id}-${i}`}
              href={s.website || "#"}
              target={s.website ? "_blank" : undefined}
              rel="noreferrer"
              data-testid={`sponsor-${s.id}-${i}`}
              className="flex items-center shrink-0 group"
            >
              {s.logo_url ? (
                <div className="bg-white px-6 py-4 rounded-lg border border-emerald-100">
                  <img src={s.logo_url} alt={s.name} className="h-12 max-w-[200px] object-contain" />
                </div>
              ) : (
                <div className="bg-emerald-900 border border-amber-300 rounded-lg px-6 py-4 min-w-[260px]">
                  <div className="text-[9px] uppercase tracking-[0.3em] text-amber-300 font-[Outfit] font-bold">{s.tier}</div>
                  <div className="font-[Cormorant_Garamond] text-white text-xl leading-tight mt-1 whitespace-nowrap">{s.name}</div>
                </div>
              )}
            </a>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes scroll {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
      `}</style>
    </section>
  );
}
